import Repository from "../Repo/Repository";

/**
 * Tell the admins that a user used a feature and how many credits it cost.
 *
 * Call it in a feature's success branch (200 OK) with the `credits_used` the
 * server returned. Failures already send /error-email, so this only covers
 * successful, charged runs. Fire-and-forget: it is never awaited, never throws
 * and never affects the feature, even if the email cannot be sent.
 */
export function sendUsageEmail(feature, creditsUsed) {
  try {
    const email = localStorage.getItem("email");
    const credits = Number(creditsUsed);
    if (!email || !feature || !(credits > 0)) return;
    Repository.post("/usage-email", { email, feature, credits_used: credits }).catch(() => {});
  } catch {
    /* never let a notification break a feature */
  }
}
